import { populateVariabiliList } from "app/redux/VariabiliStruttura/variabiliStrutturaSlice";

const { fetchData } = require("../apiService");

export const caricaVariabili = ({ handleSessionExpiry = true } = {}) => {
  const apiUrl = "VariabiliStrutture/ElencoVariabili";
  return (dispatch) => {
    return dispatch(fetchData(apiUrl, null, null, "GET", undefined, {}, handleSessionExpiry))
      .then((data) => {
        dispatch(populateVariabiliList(data));
        return data;
      })
      .catch((error) => {
        console.log("errore", error);
        return Promise.reject(error);
      });
  };
}

export const getValoreVariabileUtil = async (dispatch, nomeVariabile) => {
  const variabiliStrutture = await dispatch(caricaVariabili());
  const variabile = variabiliStrutture.find((item) => item.chiave === nomeVariabile);
  if (variabile === undefined) {
    await dispatch(salvaVariabili(nomeVariabile,''));
    const updatedVariabili = await dispatch(caricaVariabili());
    return updatedVariabili.find((item) => item.chiave === nomeVariabile)?.valore || null;
  }

  return variabile.valore;
};

export const salvaVariabili = (nomeVariabile, valore) => {
  const apiUrl = "VariabiliStrutture/GetValore";
  const payload = {
    idvariabile: 0,
    chiave: nomeVariabile,
    valore: valore !== undefined ? valore : ""
  };

  return async (dispatch) => {
    try {
      const data = await dispatch(fetchData(apiUrl, payload, null, "POST"));
      // caricaVariabili aggiorna GIA' lo store (fa populateVariabiliList al suo interno)
      await dispatch(caricaVariabili());
      return data;
    } catch (error) {
      console.log("errore", error);
      return Promise.reject(error);
    }
  };
};

export const getValoreVariabileStruttura = (variabiliStrutture, nomeVariabile) => {
  const risultato = variabiliStrutture.filter(item => item.chiave === nomeVariabile);
  if (risultato.length === 0)
    return "";
  return risultato[0].valore;
}
